module.exports = __webpack_public_path__ + "img/qwello-logo.86effe31.svg";